import ReactGA from 'react-ga';
import EventNames from '../constants/EventNames';
import AbstractGoogleAnalytics from './AbstractGoogleAnalytics';
import { GOOGLE_TRACKING_ID } from '../constants/config';

class GoogleAnalytics extends AbstractGoogleAnalytics {
  constructor() {
    super();

    // Initialize GA
    ReactGA.initialize(GOOGLE_TRACKING_ID, {
      debug: false,
    });
  }

  transformEventArgs = (name) => {
    /**
     * ReactGA.events accepts:
     *    - categroy (required): top-level category for events
     *    - action (required): event description
     *    - label: Additional information to go along with action
     *    - value: optional numerical value to record with event
     */

    const category =
      name === EventNames.ADD_PAYMENT_INFO ? 'Conversions' : 'Behavior';
    const action = name;
    return { category, action };
  };

  logEvent(name, properties = {}) {
    if (!this.shouldLogEvent(name)) return;

    if (name === EventNames.VIEW_SCREEN) {
      ReactGA.pageview(properties.screen);
    } else {
      ReactGA.event(this.transformEventArgs(name));
    }
  }
}

export default new GoogleAnalytics();
